var map = {
	"./ar.json": 520,
	"./da.json": 521,
	"./de.json": 522,
	"./en.json": 523,
	"./es.json": 524,
	"./fi.json": 525,
	"./fr.json": 526,
	"./hi.json": 527,
	"./hu.json": 528,
	"./it.json": 529,
	"./ja.json": 530,
	"./ko.json": 531,
	"./nl.json": 532,
	"./pl.json": 533,
	"./pt-BR.json": 534,
	"./sv.json": 535,
	"./th.json": 536,
	"./uk.json": 537,
	"./zh-CN.json": 538,
	"./zh-TW.json": 539
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 519;